<!--车牌键盘组件-->
<template>
  <div class="keyboard">
  <!-- 选择车牌号 首个汉字键盘 弹出层 -->
    <div class="plate_number">
        <van-popup v-model="show_chinese" position="bottom" :overlay="true" overlay-class="displayNone">
            <div class="plate_chinese_box">
                <!-- 点击对应的汉字，进行输入 -->
                <van-button size="normal" v-for="(item, index) in ChineseList"  :key="item.id" @click="checkChinese(index)">{{item.name}}</van-button>
            </div>
        </van-popup>
    </div>
    <!-- 英文数字键盘 -->
    <div class="allBoard">
        <van-popup v-model="show_allBoard" position="bottom" :overlay="true" overlay-class="displayNone">
          <div class="plate_number_box">
                <!-- 点击对应的字母或数字，进行输入 -->
                <van-button size="small" v-for="(item, index) in English_Number" :key="item.id" @click="checkEnglish_num(index)">{{item.name}}</van-button>
          </div>
        </van-popup>
    </div> 
  </div>
</template>

<style lang="scss" scoped>
/*
.keyboard {
  width: 100%;
  position: absolute;

.van-overlay {
  background:rgba(255,255,255,0)
}

.overflow-y {
  overflow-y: inherit;
}

.class-van-button-small {
  min-width: 33px;
  height: 50px;
  border-radius: 5px;
  margin: 5px 2px;
  box-shadow: 5px 5px 10px #aaa;
  height: 40px;
  font-size: 16px;
}
.plate_chinese_box {
  height: 230px;
  padding-top: 5px;
  background:#f0f0f0;
  box-sizing: border-box;
}
.class-plate-box {
  box-sizing: border-box;
  background:#f0f0f0;
}
.van-button--normal {
  width: 35.5px;
  height: 50px;
  border-radius: 5px;
  margin-left: 2px;
  margin-bottom: 4px;
  font-size: 16px;
}
.van-button--normal:nth-child(11) {
  margin-left: 5%;
}
.van-button--normal:nth-child(20) {
  margin-left: 10%;
}
.van-button--normal:nth-child(28) {
  margin-left: 15%;
}
.van-button--normal:nth-child(32) {
  color: blue;
}
.van-button--normal:nth-child(33) {
  color: blue;
}
.van-button--normal:nth-child(34) {
  color: blue;
}
.van-button--normal:last-child {
  width: 13%;
  height: 40px;
  font-size: 20px;
}
}

.allBoard {
    .van-popup {
      @extend .overflow-y;
    }

    .plate_number_box {
      width: 100%;
      height: 210px;
      @extend .class-plate-box;
      .van-button--small {
          width:8.8%;
          @extend .class-van-button-small;
      }
      .van-button--small:nth-child(1) {
        margin-bottom: 5px;
      }
      .van-button--small:nth-child(21) {
        margin-left: 5%;
      }
      .van-button--small:nth-child(30) {
        margin-left: 10%;
      }
      .van-button--small:last-child {
        width: 13%;
      }

  }
}*/
</style>

<script>
export default {
  name: 'keybord',
  data () {
    return {
      val: '', // 传递的数据
      showKeyboard: true,
      show_chinese: false,
      show_allBoard: false,
      ChineseList: [
        {name: '京', id: 1},
        {name: '津', id: 2},
        {name: '冀', id: 3},
        {name: '晋', id: 4},
        {name: '蒙', id: 5},
        {name: '辽', id: 6},
        {name: '吉', id: 7},
        {name: '黑', id: 8},
        {name: '沪', id: 9},
        {name: '苏', id: 10},
        {name: '浙', id: 11},
        {name: '皖', id: 12},
        {name: '闽', id: 13},
        {name: '赣', id: 14},
        {name: '鲁', id: 15},
        {name: '豫', id: 16},
        {name: '鄂', id: 17},
        {name: '湘', id: 18},
        {name: '粤', id: 19},
        {name: '桂', id: 20},
        {name: '琼', id: 21},
        {name: '渝', id: 22},
        {name: '川', id: 23},
        {name: '贵', id: 24},
        {name: '云', id: 25},
        {name: '藏', id: 26},
        {name: '陕', id: 27},
        {name: '甘', id: 28},
        {name: '青', id: 29},
        {name: '宁', id: 30},
        {name: '新', id: 31},
        {name: '军', id: 33},
        {name: '警', id: 34},
        {name: '学', id: 35},
        {name: '←', id: 99}
      ],
      English_Number: [
        {name: '1', id: 28},
        {name: '2', id: 29},
        {name: '3', id: 30},
        {name: '4', id: 31},
        {name: '5', id: 32},
        {name: '6', id: 33},
        {name: '7', id: 34},
        {name: '8', id: 35},
        {name: '9', id: 36},
        {name: '0', id: 37},
        {name: 'Q', id: 38},
        {name: 'W', id: 39},
        {name: 'E', id: 40},
        {name: 'R', id: 41},
        {name: 'T', id: 42},
        {name: 'Y', id: 43},
        {name: 'U', id: 44},
        {name: 'I', id: 45},
        {name: 'O', id: 46},
        {name: 'P', id: 47},
        {name: 'A', id: 48},
        {name: 'S', id: 49},
        {name: 'D', id: 50},
        {name: 'F', id: 51},
        {name: 'G', id: 52},
        {name: 'H', id: 53},
        {name: 'J', id: 54},
        {name: 'K', id: 55},
        {name: 'L', id: 56},
        {name: 'Z', id: 57},
        {name: 'X', id: 58},
        {name: 'C', id: 59},
        {name: 'V', id: 60},
        {name: 'B', id: 61},
        {name: 'N', id: 62},
        {name: 'M', id: 63},
        {name: '←', id: 99}
      ]
    }
  },
  methods: {
    // 唤起键盘
    clickShowKeyboard () {
      if (!this.val.length <= 1) {
        this.show_chinese = true
      } else {
        this.show_chinese = false
        this.show_allBoard = true
      }
    },

    // 选择车牌号前面的汉字
    checkChinese (index) {
      // 如果点击删除键，删除第一个格的内容
      if (this.ChineseList[index].id === 99) {
        this.val = this.val.slice(0, this.val.length - 1)
      } else {
        // 把选中的字赋值给第一个格，并且切换键盘
        this.val = this.ChineseList[index].name
        this.show_chinese = false
        this.show_allBoard = true
      }
      this.$emit('getVal', this.val)
    },
    // 选择车牌号后面的数字和字母
    checkEnglish_num (index) {
    // 如果点击删除键，删除 value 的最后一个值
      if (this.English_Number[index].id === 99) {
        this.val = this.val.slice(0, this.val.length - 1)
        // 如果 value 里面被删的没有值了，切换键盘
        if (this.val.length === 0) {
          this.show_chinese = true
          this.show_allBoard = false
        }
      } else {
        this.val += this.English_Number[index].name
      }
      // 如果车牌大于七位数停止输入
      if (this.val.length >= 8) {
        this.val = this.val.slice(0, this.val.length - 1)
      }
      this.$emit('getV', this.val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/card/keybord.vue